import { __extends } from "tslib";
import { DescribeChannelMembershipForAppInstanceUserRequest, DescribeChannelMembershipForAppInstanceUserResponse, } from "../models/models_0";
import { deserializeAws_restJson1DescribeChannelMembershipForAppInstanceUserCommand, serializeAws_restJson1DescribeChannelMembershipForAppInstanceUserCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
/**
 * <p> Returns the details of a channel based on the membership of the specified
 *             <code>AppInstanceUser</code>.</p>
 *
 *          <note>
 *             <p>The <code>x-amz-chime-bearer</code> request header is mandatory. Use the
 *                <code>AppInstanceUserArn</code> of the user that makes the API call as the value in
 *             the header.</p>
 *          </note>
 * @example
 * Use a bare-bones client and the command you need to make an API call.
 * ```javascript
 * import { ChimeSDKMessagingClient, DescribeChannelMembershipForAppInstanceUserCommand } from "@aws-sdk/client-chime-sdk-messaging"; // ES Modules import
 * // const { ChimeSDKMessagingClient, DescribeChannelMembershipForAppInstanceUserCommand } = require("@aws-sdk/client-chime-sdk-messaging"); // CommonJS import
 * const client = new ChimeSDKMessagingClient(config);
 * const command = new DescribeChannelMembershipForAppInstanceUserCommand(input);
 * const response = await client.send(command);
 * ```
 *
 * @see {@link DescribeChannelMembershipForAppInstanceUserCommandInput} for command's `input` shape.
 * @see {@link DescribeChannelMembershipForAppInstanceUserCommandOutput} for command's `response` shape.
 * @see {@link ChimeSDKMessagingClientResolvedConfig | config} for command's `input` shape.
 *
 */
var DescribeChannelMembershipForAppInstanceUserCommand = /** @class */ (function (_super) {
    __extends(DescribeChannelMembershipForAppInstanceUserCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DescribeChannelMembershipForAppInstanceUserCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DescribeChannelMembershipForAppInstanceUserCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "ChimeSDKMessagingClient";
        var commandName = "DescribeChannelMembershipForAppInstanceUserCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: DescribeChannelMembershipForAppInstanceUserRequest.filterSensitiveLog,
            outputFilterSensitiveLog: DescribeChannelMembershipForAppInstanceUserResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeChannelMembershipForAppInstanceUserCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1DescribeChannelMembershipForAppInstanceUserCommand(input, context);
    };
    DescribeChannelMembershipForAppInstanceUserCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1DescribeChannelMembershipForAppInstanceUserCommand(output, context);
    };
    return DescribeChannelMembershipForAppInstanceUserCommand;
}($Command));
export { DescribeChannelMembershipForAppInstanceUserCommand };
//# sourceMappingURL=DescribeChannelMembershipForAppInstanceUserCommand.js.map